import Vue from 'vue'
import Vuex from 'vuex'
import { MANUAL_SW, SAMPLE_SW, CAMERA_SW, ADD_INPUT, DEL_INPUT, UPDATE_LABEL, UPDATE_ACT, ADD_IMAGE, SET_IMAGE, DEL_IMAGE, DISP_MODAL_CHG,
  SET_KITIP, SET_MESSAGE, SET_PROGBAR, SET_TRAIN_DISABLE, ADD_AIMODEL, UPDATE_AIPARAM, DEL_AIMODEL, SET_AIRESULT, UPDATE_CONTKIT,
  SET_ALWAYSPRED, SET_ACTCONF, ADD_ACTCONF, DEL_ACTCONF, SET_KITDATA, LOAD_FILE } from './mutation-types'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // manualInputFlag: 2,
    manualInputFlag: 0,
    samplebtn: 'MNIST',
    kitDataType: 'marubatu',
    // cameraInput: 'kit',
    // cameraPredict: 'kit',
    cameraInput: 'pen',
    cameraPredict: 'pen',
    inputs: [{id: 0, name: '0', act: 0}, {id: 1, name: '1', act: 0}, {id: 2, name: '2', act: 0}, {id: 3, name: '3', act: 0}, {id: 4, name: '4', act: 0},
      {id: 5, name: '5', act: 0}, {id: 6, name: '6', act: 0}, {id: 7, name: '7', act: 0}, {id: 8, name: '8', act: 0}, {id: 9, name: '9', act: 0}], // 0-9の10個
    iimages: [],
    /* inputs: [{id: 0, name: '1', act: 0}, {id: 1, name: '2', act: 0}],
    iimages: [{in_id: 0, img_num: 1, img_data: ''}, {in_id: 1, img_num: 1, img_data: ''}], */
    aimodels: [ { no: 1, type: 'Conv', val1: '8', val2: 'relu' }, { no: 2, type: 'Pool', val1: '0', val2: '0' },
      { no: 3, type: 'Conv', val1: '16', val2: 'relu' }, { no: 4, type: 'Pool', val1: '0', val2: '0' }, { no: 5, type: 'Flat', val1: '0', val2: '0' } ],
    aimodelpara: {epochs: 10, optim: 'adam', valid: 0},
    setActions: [ { no: 1, act: 'Car-Go', url: '/cargo?a=GO&ai=1' }, { no: 2, act: 'Car-Stop', url: '/cargo?a=STOP&ai=1' }, { no: 3, act: 'Car-BACK', url: '/cargo?a=BACK&ai=1' },
      { no: 4, act: 'Car-Right', url: '/carturn?a=RIGHT&n=200&ai=1' }, { no: 5, act: 'Car-Left', url: '/carturn?a=LEFT&n=200&ai=1' },
      { no: 6, act: 'Remocon-Send1', url: '/cntrem?n=0' }, { no: 7, act: 'Remocon-Send2', url: '/cntrem?n=1' }, { no: 8, act: 'Remocon-Send3', url: '/cntrem?n=2' },
      { no: 9, act: 'Remocon-Send4', url: '/cntrem?n=3' }, { no: 10, act: 'Remocon-Send5', url: '/cntrem?n=4' }],
    setModals: {modalin: 1, modalimg: 1, modalkit: false, modalpc: false, modalpen: false},
    setKits: {ipstate: false, kitip: ''},
    resultGraph: {loss: [], acc: [], vloss: [], vacc: []},
    model: null,
    controlKits: {renkei: false, ipstate: false, kitip: ''},
    alwaysPredict: false,
    // 以下は設定保存不要
    // aidatas: [], // iimagesと分割（Save時に保存しないがTrain時に時間がかからないようにメモリ保存）
    trainBtnDisable: false,
    dispMessage: '',
    progbars: {value: 0, show: false},
    width: 28,
    height: 28
  },
  getters: {
    getInput (state) {
      return inputNum => {
        return state.inputs.filter(input => input.in_id === inputNum)
      }
    },
    getAllImages (state) {
      return inputNum => {
        if (inputNum === 99999) {
          return state.iimages
        } else {
          return state.iimages.filter(iimage => iimage.in_id === inputNum)
        }
      }
    },
    getImage (state) {
      return pyload => {
        // console.log('getImage:' + pyload.in_idb + ':' + pyload.img_numb)
        var findIndex = state.iimages.findIndex(iimage => (iimage.in_id === pyload.in_id && iimage.img_num === pyload.img_numb))
        return state.iimages[findIndex]
      }
    }
  },
  mutations: {
    [MANUAL_SW] (state, swFlag) {
      state.manualInputFlag = swFlag
      if (swFlag === 2) {
        state.inputs = [{id: 0, name: '1', act: 0}, {id: 1, name: '2', act: 0}] // 2つ以外全て削除
        state.iimages = [{in_id: 0, img_num: 1, img_data: ''}, {in_id: 1, img_num: 1, img_data: ''}] // inputs.idは0始まり、iimages.img_numは１始まり
      } else if (swFlag === 1) {
        state.inputs = []
        state.iimages = []
      } else if (swFlag === 0) {
        state.inputs = [{id: 0, name: '0', act: 0}, {id: 1, name: '1', act: 0}, {id: 2, name: '2', act: 0}, {id: 3, name: '3', act: 0}, {id: 4, name: '4', act: 0},
          {id: 5, name: '5', act: 0}, {id: 6, name: '6', act: 0}, {id: 7, name: '7', act: 0}, {id: 8, name: '8', act: 0}, {id: 9, name: '9', act: 0}] // 0-9の10個
        state.iimages = []
      }
      state.samplebtn = 'MNIST'
      // state.cameraInput = 'kit'
      state.cameraInput = 'pen'
    },
    [SAMPLE_SW] (state, swFlag) {
      if (swFlag === 0) {
        state.samplebtn = 'MNIST'
        state.inputs = [{id: 0, name: '0', act: 0}, {id: 1, name: '1', act: 0}, {id: 2, name: '2', act: 0}, {id: 3, name: '3', act: 0}, {id: 4, name: '4', act: 0},
          {id: 5, name: '5', act: 0}, {id: 6, name: '6', act: 0}, {id: 7, name: '7', act: 0}, {id: 8, name: '8', act: 0}, {id: 9, name: '9', act: 0}] // 0-9の10個
        state.iimages = []
      } else {
        state.samplebtn = 'KITDATA'
        state.inputs = [{id: 0, name: 'マル', act: 0}, {id: 1, name: 'バツ', act: 0}] // 0-9の10個
        state.iimages = []
      }
    },
    [CAMERA_SW] (state, payload) {
      if (payload.jobType === 'input') {
        // ***********************「iimages」と「inputs」の初期化***********************
        // console.log('store_UPDATE_CSW:' + String(swFlag))
        // state.iimages.splice(1, (Object.keys(state.iimages).length - 1)) // １つ以外全て削除
        state.iimages = [{in_id: 0, img_num: 1, img_data: ''}, {in_id: 1, img_num: 1, img_data: ''}]
        // state.inputs.splice(1, (Object.keys(state.inputs).length - 2)) // 2つ以外全て削除（NG:1,2が残らず1,4とかになる）
        state.inputs = [{id: 0, name: '1', act: 0}, {id: 1, name: '2', act: 0}] // 2つ以外全て削除
        /* NG
        state.inputs = [{
          in_id: 1,
          in_act: 0
        }] */
        if (payload.swFlag === 0) {
          state.cameraInput = 'pen'
        } else if (payload.swFlag === 1) {
          state.cameraInput = 'pc'
        } else {
          state.cameraInput = 'kit'
        }
      } else {
        if (payload.swFlag === 0) {
          state.cameraPredict = 'pen'
        } else if (payload.swFlag === 1) {
          state.cameraPredict = 'pc'
        } else {
          state.cameraPredict = 'kit'
        }
      }
    },
    [ADD_INPUT] (state) {
      var searchNum = 0 // inputs.idは0始まり、iimages.img_numは１始まり
      var searchFlag = true
      for (var i = 0; i < 999; i++) {
        searchFlag = true
        for (var key in state.inputs) {
          if (state.inputs[key].id === i) {
            searchFlag = false
            break
          }
        }
        if (searchFlag) {
          searchNum = i
          break
        }
      }
      var nameNum = String(searchNum + 1)
      let newItem = {
        id: searchNum,
        name: nameNum,
        act: 0
      }
      // console.log('store_addInput:' + String(newItem.in_id) + ':' + String(newItem.in_act))
      state.inputs.push(newItem)
      // ADD IMAGE(作成時は必ず１つImageBox)
      let newImageItem = {
        in_id: searchNum,
        img_num: 1,
        img_data: ''
      }
      state.iimages.push(newImageItem)
      // Sort Inputs
      state.inputs = state.inputs.sort((a, b) => {
        return (a.id < b.id) ? -1 : (a.id > b.id) ? 1 : 0
      })
    },
    [UPDATE_ACT] (state, payload) {
      var updIndex = state.inputs.findIndex(input => input.id === payload.upd_id)
      state.inputs[updIndex].act = payload.upd_act
      // console.log('UPDATE_ACT:' + state.inputs[updIndex].id + ':' + payload.upd_act)
    },
    [DEL_INPUT] (state, delnum) {
      // alert(delnum)
      var delIndex = state.inputs.findIndex(input => input.id === delnum)
      state.inputs.splice(delIndex, 1)
      /* xxx.vueにMethodで記述時は以下でOK
      state.inputs = state.inputs.filter(function (delItem) {
        return delItem.in_id !== delnum
      }) */
      // Imageの削除
      state.iimages = state.iimages.filter(iimage => iimage.in_id !== delnum)
    },
    [UPDATE_LABEL] (state, payload) {
      var updIndex = state.inputs.findIndex(input => input.id === payload.in_id)
      if (updIndex === -1) {
        let newItem = {
          id: payload.in_id,
          name: payload.in_label,
          act: 0
        }
        // console.log('store_addInput:' + String(newItem.in_id) + ':' + String(newItem.in_act))
        state.inputs.push(newItem)
        state.inputs = state.inputs.sort((a, b) => { return (a.id < b.id) ? -1 : (a.id > b.id) ? 1 : 0 })
      } else {
        state.inputs[updIndex].name = payload.in_label
      }
    },
    [ADD_IMAGE] (state, payload) {
      var searchNum = 1 // inputs.idは0始まり、iimages.img_numは１始まり
      var searchFlag = true
      for (var i = 1; i < 1000; i++) {
        searchFlag = true
        for (var key in state.iimages) {
          if (state.iimages[key].in_id === payload.in_id && state.iimages[key].img_num === i) {
            searchFlag = false
            break
          }
        }
        if (searchFlag) {
          searchNum = i
          break
        }
      }
      // InputCard作成時に既にある場合は追加しない
      if (payload.createFlag && searchFlag && searchNum !== 1) {
      } else {
        let newItem = {
          in_id: payload.in_id,
          img_num: searchNum,
          img_data: ''
        }
        // console.log('store_addImage:' + String(payload.in_id) + ':' + String(searchNum))
        state.iimages.push(newItem)
        // Add時にaidatasは追加しない。Set時に追加
        // Sort iimages
        state.iimages = state.iimages.sort((a, b) => {
          return (a.img_num < b.img_num) ? -1 : (a.img_num > b.img_num) ? 1 : 0
        })
      }
    },
    [SET_IMAGE] (state, payload) {
      // ******** -1,-1の場合はデータReset（データクリア）********
      if (payload.s_in === -1 && payload.s_img === -1) {
        state.iimages = []
        state.aidatas = []
        return
      }
      // ******** iimages ********
      var updIndex = state.iimages.findIndex(iimage => (iimage.in_id === payload.s_in && iimage.img_num === payload.s_img))
      // 存在しない場合はimgデータ追加しIndex更新
      if (updIndex === -1) {
        let newItem = {
          in_id: payload.s_in,
          img_num: payload.s_img,
          img_data: ''
        }
        state.iimages.push(newItem)
        updIndex = state.iimages.findIndex(iimage => (iimage.in_id === payload.s_in && iimage.img_num === payload.s_img))
      }
      state.iimages[updIndex].img_data = payload.s_data
    },
    /* [SET_AIDATA] (state, payload) {
      // ******** aidatas関連の更新 ********
      var updIndex = state.aidatas.findIndex(aidata => (aidata.in_id === payload.s_in && aidata.img_num === payload.s_img))
      // 存在しない場合はimgデータ追加しIndex更新
      if (updIndex === -1) {
        let newItem = {
          in_id: payload.s_in,
          img_num: payload.s_img,
          ai_data: ''
        }
        state.aidatas.push(newItem)
        updIndex = state.aidatas.findIndex(aidata => (aidata.in_id === payload.s_in && aidata.img_num === payload.s_img))
      }
      // Change data RGBA(4) => RGB(3)
      var aiDataArr = payload.s_aid
      // var rgbdata = [] // 1次元データ、3:RGB
      var graydata = [] // 1次元データ、1:GRAY
      var x28data = [] // 2次元データ、4*176
      var x2828data = [] // 3次元データ、4*176*144
      // console.log(aiDataArr.length)
      for (var i = 0; i < aiDataArr.length; i += 4) {
        /* RGBA(4)=>RGB(3)へ変換していたが性能が悪いため、Grayスケール(1)へ変更
        if ((aiDataArr.length / state.width / state.height) === 4) {
          if (aiDataArr[i] === 0 && aiDataArr[(i + 1)] === 0 && aiDataArr[(i + 2)] === 0) {
            rgbdata.push(aiDataArr[(i + 3)])
            rgbdata.push(aiDataArr[(i + 3)])
            rgbdata.push(aiDataArr[(i + 3)])
          } else {
            rgbdata.push(aiDataArr[i])
            rgbdata.push(aiDataArr[(i + 1)])
            rgbdata.push(aiDataArr[(i + 2)])
          }
        } else {
          rgbdata.push(aiDataArr[i])
          rgbdata.push(aiDataArr[(i + 1)])
          rgbdata.push(aiDataArr[(i + 2)])
        } */
    /* // Gayスケール作成
        var culcGray = 0
        if (aiDataArr[i] === 0 && aiDataArr[(i + 1)] === 0 && aiDataArr[(i + 2)] === 0 && aiDataArr[(i + 3)] !== 255) {
          culcGray = aiDataArr[(i + 3)]
        } else {
          culcGray = ((aiDataArr[i] + aiDataArr[(i + 1)] + aiDataArr[(i + 2)]) / 3)
        }
        graydata.push(culcGray)
        // Push each RGB for Line
        x28data.push(graydata)
        graydata = []
        // Push each 1line(x-Line) for Input
        if (i === (state.width * 4) * x2828data.length + ((state.width - 1) * 4)) {
          x2828data.push(x28data)
          x28data = []
        }
      }
      // console.log('SET_IMAGE:' + payload.s_in + ':' + payload.s_img + ':' + x144176data)
      // console.log(x2828data)
      state.aidatas[updIndex].ai_data = x2828data
    }, */
    [DEL_IMAGE] (state, payload) {
      // console.log('store_delImage3:' + String(payload.del_in) + ':' + String(payload.del_img))
      // iimagesの削除
      state.iimages = state.iimages.filter(iimage => !(iimage.in_id === payload.del_in && iimage.img_num === payload.del_img))
      // aidatasの削除（上記のように1行でも可）
      // var delIndex = state.aidatas.findIndex(aidata => (aidata.in_id === payload.del_in && aidata.img_num === payload.del_img))
      // state.aidatas.splice(delIndex, 1)
      /* xxx.vueにMethodで記述時は以下でOK
      this.iimages = this.iimages.filter(function (delItem) {
        return delItem.img_num !== delnum
      }) */
    },
    [DISP_MODAL_CHG] (state, payload) {
      state.setModals.modalin = payload.s_in
      state.setModals.modalimg = payload.s_img
      if (state.cameraInput === 'pc') {
        state.setModals.modalpc = !state.setModals.modalpc
      } else if (state.cameraInput === 'pen') {
        state.setModals.modalpen = !state.setModals.modalpen
      } else {
        if (state.setKits.ipstate) {
          state.setModals.modalkit = !state.setModals.modalkit
        } else {
          state.dispMessage = 'キットのIPアドレスを入力して下さい'
        }
      }
    },
    [SET_KITIP] (state, payload) {
      state.setKits.kitip = payload.s_ip
      state.setKits.ipstate = payload.s_st
      state.dispMessage = ''
    },
    [SET_MESSAGE] (state, payload) {
      state.dispMessage = payload
      // console.log('SET_MESSAGE:' + state.dispMessage)
    },
    [SET_PROGBAR] (state, payload) {
      state.progbars.value = payload.s_value
      // state.progbars.show = payload.s_show
    },
    [SET_TRAIN_DISABLE] (state, payload) {
      state.trainBtnDisable = payload
      // console.log('SET_TRAIN_DISABLE:' + payload)
    },
    [ADD_AIMODEL] (state, payload) {
      var searchNum = 1
      var searchFlag = true
      for (var i = 1; i < 1000; i++) {
        searchFlag = true
        for (var key in state.aimodels) {
          if (state.aimodels[key].no === i) {
            searchFlag = false
            break
          }
        }
        if (searchFlag) {
          searchNum = i
          break
        }
      }
      let newItem = {
        no: searchNum,
        type: payload.type,
        val1: payload.val1,
        val2: payload.val2
      }
      // console.log('ADD_AIMODEL:' + String(newItem.no) + ':' + newItem.val)
      state.aimodels.push(newItem)
      state.aimodels = state.aimodels.sort((a, b) => {
        return (a.no < b.no) ? -1 : (a.no > b.no) ? 1 : 0
      })
    },
    [UPDATE_AIPARAM] (state, payload) {
      // console.log('UPDATE_AIPARAM:' + String(payload.epochs) + ':' + payload.optim)
      state.aimodelpara.epochs = payload.epochs
      state.aimodelpara.optim = payload.optim
      state.aimodelpara.valid = payload.valid
    },
    [DEL_AIMODEL] (state, payload) {
      state.aimodels = state.aimodels.filter(aimodel => aimodel.no !== payload)
    },
    [SET_AIRESULT] (state, payload) {
      if (payload.loss !== -1) {
        state.resultGraph.loss = payload.loss
        state.resultGraph.acc = payload.acc
        state.resultGraph.vloss = payload.vloss
        state.resultGraph.vacc = payload.vacc
      }
      state.model = payload.model
    },
    [UPDATE_CONTKIT] (state, payload) {
      state.controlKits.renkei = payload.renkei
      state.controlKits.ipstate = payload.s_st
      state.controlKits.kitip = payload.s_ip
      // kit連携時は常時予測は実施しない
      /* if (payload.renkei) {
        state.alwaysPredict = false
      } */
    },
    [SET_ALWAYSPRED] (state, payload) {
      state.alwaysPredict = payload
      // 常時予測時はkit連携は実施しない
      /* if (payload) {
        state.controlKits.renkei = false
      } */
    },
    [SET_ACTCONF] (state, payload) {
      state.setActions = []
      for (let j = 0; j < payload.length; j++) {
        const eachVal = { no: payload[j].no, act: payload[j].act, url: payload[j].url }
        state.setActions.push(eachVal)
      }
      state.setActions = state.setActions.sort((a, b) => {
        return (a.no < b.no) ? -1 : (a.no > b.no) ? 1 : 0
      })
    },
    [ADD_ACTCONF] (state) {
      var searchNum = 1
      var searchFlag = true
      for (var i = 1; i < 1000; i++) {
        searchFlag = true
        for (var key in state.setActions) {
          if (state.setActions[key].no === i) {
            searchFlag = false
            break
          }
        }
        if (searchFlag) {
          searchNum = i
          break
        }
      }
      let newItem = {
        no: searchNum,
        act: '',
        url: ''
      }
      state.setActions.push(newItem)
      state.setActions = state.setActions.sort((a, b) => {
        return (a.no < b.no) ? -1 : (a.no > b.no) ? 1 : 0
      })
    },
    [DEL_ACTCONF] (state, payload) {
      state.setActions = state.setActions.filter(setAction => setAction.no !== payload)
    },
    [SET_KITDATA] (state, payload) {
      state.kitDataType = payload
    },
    async [LOAD_FILE] (state, payload) {
      // 常時予測はFlaseへ
      state.alwaysPredict = false
      var loadArr = payload.split(/\r\n|\n/)
      for (var i = 0; i < loadArr.length; i++) {
        if (loadArr[i].match(/manualInputFlag/)) {
          console.log('manualInputFlag!')
          const valArr = loadArr[i].split('\t')
          if (valArr[1] !== 'undefined' && valArr[1] !== null && valArr[1] !== '') {
            state.manualInputFlag = parseInt(valArr[1])
          }
        } else if (loadArr[i].match(/samplebtn/)) {
          console.log('samplebtn!')
          const valArr = loadArr[i].split('\t')
          if (valArr[1] !== 'undefined' && valArr[1] !== null && valArr[1] !== '') {
            state.samplebtn = valArr[1]
          }
        } else if (loadArr[i].match(/kitDataType/)) {
          console.log('kitDataType!')
          const valArr = loadArr[i].split('\t')
          if (valArr[1] !== 'undefined' && valArr[1] !== null && valArr[1] !== '') {
            state.kitDataType = valArr[1]
          }
        } else if (loadArr[i].match(/cameraInput/)) {
          console.log('cameraInput!')
          const valArr = loadArr[i].split('\t')
          if (valArr[1] !== 'undefined' && valArr[1] !== null && valArr[1] !== '') {
            state.cameraInput = valArr[1]
          }
        } else if (loadArr[i].match(/cameraPredict/)) {
          console.log('cameraPredict!')
          const valArr = loadArr[i].split('\t')
          if (valArr[1] !== 'undefined' && valArr[1] !== null && valArr[1] !== '') {
            state.cameraPredict = valArr[1]
          }
        } else if (loadArr[i].match(/inputs/)) {
          console.log('inputs!')
          const valArr = loadArr[i].split('\t')
          if (valArr[1] !== 'undefined' && valArr[1] !== null && valArr[1] !== '') {
            state.inputs = JSON.parse(valArr[1])
          }
        /* 読み込みに時間がかかるので他のパラメータを全て先に読み込む（グラフなどを表示させるため）
        } else if (loadArr[i].match(/iimages/)) {
          console.log('iimages!')
          const valArr = loadArr[i].split('\t')
          if (valArr[1] !== 'undefined' && valArr[1] !== null && valArr[1] !== '') {
            state.iimages = await JSON.parse(valArr[1])
          } */
        } else if (loadArr[i].match(/aimodels/)) {
          console.log('aimodels!')
          const valArr = loadArr[i].split('\t')
          if (valArr[1] !== 'undefined' && valArr[1] !== null && valArr[1] !== '') {
            state.aimodels = JSON.parse(valArr[1])
          }
        } else if (loadArr[i].match(/aimodelpara/)) {
          console.log('aimodelpara!')
          const valArr = loadArr[i].split('\t')
          if (valArr[1] !== 'undefined' && valArr[1] !== null && valArr[1] !== '') {
            state.aimodelpara = JSON.parse(valArr[1])
          }
        } else if (loadArr[i].match(/setActions/)) {
          console.log('setActions!')
          const valArr = loadArr[i].split('\t')
          if (valArr[1] !== 'undefined' && valArr[1] !== null && valArr[1] !== '') {
            state.setActions = JSON.parse(valArr[1])
          }
        } else if (loadArr[i].match(/setModals/)) {
          console.log('setModals!')
          const valArr = loadArr[i].split('\t')
          if (valArr[1] !== 'undefined' && valArr[1] !== null && valArr[1] !== '') {
            state.setModals = JSON.parse(valArr[1])
          }
        } else if (loadArr[i].match(/setKits/)) {
          console.log('setKits!')
          const valArr = loadArr[i].split('\t')
          if (valArr[1] !== 'undefined' && valArr[1] !== null && valArr[1] !== '') {
            state.setKits = JSON.parse(valArr[1])
          }
        } else if (loadArr[i].match(/resultGraph/)) {
          console.log('resultGraph!')
          const valArr = loadArr[i].split('\t')
          if (valArr[1] !== 'undefined' && valArr[1] !== null && valArr[1] !== '') {
            state.resultGraph = JSON.parse(valArr[1])
          }
        } else if (loadArr[i].match(/model/)) {
          console.log('model!')
          const valArr = loadArr[i].split('\t')
          if (valArr[1] !== 'undefined' && valArr[1] !== null && valArr[1] !== '') {
            state.model = valArr[1]
          }
        } else if (loadArr[i].match(/controlKits/)) {
          console.log('controlKits!')
          const valArr = loadArr[i].split('\t')
          if (valArr[1] !== 'undefined' && valArr[1] !== null && valArr[1] !== '') {
            state.controlKits = JSON.parse(valArr[1])
          }
        }
      }
      for (var j = 0; j < loadArr.length; j++) {
        if (loadArr[j].match(/iimages/)) {
          console.log('iimages!')
          const valArr = loadArr[j].split('\t')
          if (valArr[1] !== 'undefined' && valArr[1] !== null && valArr[1] !== '') {
            state.iimages = await JSON.parse(valArr[1])
          }
        }
      }
      console.log('STORE:LOAD_FILE')
    }
  },
  actions: {
    [MANUAL_SW] ({ commit }, swFlag) {
      commit(MANUAL_SW, swFlag)
    },
    [SAMPLE_SW] ({ commit }, swFlag) {
      commit(SAMPLE_SW, swFlag)
    },
    [CAMERA_SW] ({ commit }, swFlag) {
      commit(CAMERA_SW, swFlag)
    },
    [ADD_INPUT] ({ commit }) {
      commit(ADD_INPUT)
    },
    [DEL_INPUT] ({ commit }, delnum) {
      commit(DEL_INPUT, delnum)
    },
    [UPDATE_LABEL] ({ commit }, payload) {
      commit(UPDATE_LABEL, payload)
    },
    [UPDATE_ACT] ({ commit }, payl) {
      commit(UPDATE_ACT, payl)
    },
    [ADD_IMAGE] ({ commit }, innum) {
      commit(ADD_IMAGE, innum)
    },
    [SET_IMAGE] ({ commit }, payl) {
      commit(SET_IMAGE, payl)
    },
    [DEL_IMAGE] ({ commit }, payl) {
      commit(DEL_IMAGE, payl)
    },
    [DISP_MODAL_CHG] ({ commit }, pay) {
      commit(DISP_MODAL_CHG, pay)
    },
    [SET_KITIP] ({ commit }, pay) {
      commit(SET_KITIP, pay)
    },
    [SET_MESSAGE] ({ commit }, pay) {
      commit(SET_MESSAGE, pay)
    },
    [SET_PROGBAR] ({ commit }, pay) {
      commit(SET_PROGBAR, pay)
    },
    [SET_TRAIN_DISABLE] ({ commit }, pay) {
      commit(SET_TRAIN_DISABLE, pay)
    },
    [ADD_AIMODEL] ({ commit }, pay) {
      commit(ADD_AIMODEL, pay)
    },
    [UPDATE_AIPARAM] ({ commit }, pay) {
      commit(UPDATE_AIPARAM, pay)
    },
    [DEL_AIMODEL] ({ commit }, pay) {
      commit(DEL_AIMODEL, pay)
    },
    [SET_AIRESULT] ({ commit }, pay) {
      commit(SET_AIRESULT, pay)
    },
    [UPDATE_CONTKIT] ({ commit }, pay) {
      commit(UPDATE_CONTKIT, pay)
    },
    [SET_ALWAYSPRED] ({ commit }, pay) {
      commit(SET_ALWAYSPRED, pay)
    },
    [SET_ACTCONF] ({ commit }, pay) {
      commit(SET_ACTCONF, pay)
    },
    [ADD_ACTCONF] ({ commit }) {
      commit(ADD_ACTCONF)
    },
    [DEL_ACTCONF] ({ commit }, pay) {
      commit(DEL_ACTCONF, pay)
    },
    [SET_KITDATA] ({ commit }, pay) {
      commit(SET_KITDATA, pay)
    },
    [LOAD_FILE] ({ commit }, pay) {
      commit(LOAD_FILE, pay)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js